<template>
  <div>
    <div class="panel panel-default" style="margin-top:20px;">
      <div class="panel-heading">
        <strong>Payment options</strong>
      </div>

      <div class="panel-body">
        <div class="row text-center">

          <!-- Single -->
          <div class="col-md-3">
            <a target="_blank" href="/account/upgrade?io_single_review=true" class="plan-card plan-card-green">

              <div class="plan-title">
                Single Client Review
              </div>

              <div class="plan-price">
                £7.00 + Vat
              </div>

              <div class="plan-subtitle">
                Single review
              </div>

            </a>
          </div>

          <!-- Bulk -->
          <div class="col-md-3">
            <a target="_blank" href="/account/upgrade?io_bulk_review=true" class="plan-card plan-card-green">

              <div class="plan-title">
                10 Client Reviews
              </div>

              <div class="plan-price">
                £50.00 + Vat
              </div>

              <div class="plan-subtitle">
                Bulk package
              </div>

            </a>
          </div>

        </div>
      </div>

      <p>
        MO®nitorAI client file review will enable automated client file document verification checks and product and related document checks. This can be run across a single client review or a bulk of 10 clients. Please choose which option you require above
      </p>

    </div>
  </div>
</template>

<script>

export default {
  props: [],
  data() {
    return {

    }
  },
}
</script>

<style scoped>
.plan-card {
  display: block;
  padding: 15px 10px;
  border-radius: 15px;
  text-decoration: none;
  color: #fff;
  transition: 0.25s ease;
  margin-bottom: 20px;
}

.plan-card:hover {
  transform: translateY(-5px);
  text-decoration: none;
  color: #fff;
}

/* Colors */
.plan-card-green {
  background: #79b7a8;
}

.plan-card-yellow {
  background: #e6b800;
}

/* Text */
.plan-title {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 5px;
}

.plan-price {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 5px;
}

.plan-subtitle {
  font-size: 12px;
  opacity: 0.9;
}
</style>